export default __webpack_public_path__ + "static/media/bell_s.4076f322.svg";